/**
 * Action kind: readmore — a link, not a button.
 *
 * For editorial placements (lookbooks, journal entries, category stories)
 * where the card is an invitation to read rather than to buy. Deliberately
 * unstyled as a button: nothing is being purchased, so nothing should look
 * like a purchase control.
 */

import { el, svg } from '../../dom.js';

const ARROW = '<path d="M5 12h14M13 6l6 6-6 6"/>';

export function render(model) {
	return el('a', { href: model.href, class: 'rfhq-pc-link' }, [
		model.actions.label || 'Read more',
		svg(ARROW, { class: 'rfhq-pc-link__icon' }),
	]);
}
